import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e08eb09c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "contents" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 프리랜서, 근로자의 환급액 조회를 위해 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 삼쩜삼으로 이동할게요 ")
const _hoisted_5 = { class: "logo-wrapper" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_8 = { class: "description" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 유의사항 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 이 서비스는 더낸세금 제휴사인 ‘(주)자비스앤빌런즈'에서 제공합니다. ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 서비스 이용은 삼쩜삼에 문의해 주시기 바랍니다. ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 삼쩜삼 고객센터 : 1688-7198 ")

import { onMounted, onBeforeUnmount } from 'vue'
import Cookies from 'js-cookie'

import BaseModal from '@/components/BaseModal.vue'
import { LeftArrow } from '@/styles/icon'
import Text from '@/components/common/TextComponent.vue'
import { COLOR_SET } from '@/styles/variables'
import { getImageUrl } from '@/utils/getImageUrl'


export default /*#__PURE__*/_defineComponent({
  name: 'FreelancerModal',
  emits: ["close"],
  setup(__props) {



let timeout: number

onMounted(() => {
  const gaCookie = Cookies.get('_ga')?.toString().split('.').slice(2,4).join('.')
  timeout = window.setTimeout(() => {
    const ga = window?.gaGlobal?.vid || gaCookie || ''
    window.location.href = `https://app.3o3.co.kr/login?utm_source=heum&utm_medium=partnership&utm_campaign=CPA-heum-partnership_atc_non__cpa_2504&utm_content=partnership_atc_non_2504&utm_term=250421_logo_non&client_id=${ga}`
  }, 3000)
})

onBeforeUnmount(() => {
  if (timeout) {
    clearTimeout(timeout)
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, { "is-full-no-padding": "" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(LeftArrow), {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createVNode(Text, {
            color: _unref(COLOR_SET).gray015
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["color"]),
          _createVNode(Text, {
            size: "20px",
            weight: "bold",
            margin: "6px 0 0 0"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            class: "logo",
            src: _unref(getImageUrl)('icons/33.png')
          }, null, 8, _hoisted_6),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(Text, {
            color: _unref(COLOR_SET).gray015,
            weight: "bold",
            size: "14px"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["color"]),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(Text, {
                color: _unref(COLOR_SET).gray015,
                size: "14px"
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["color"])
            ]),
            _createElementVNode("li", null, [
              _createVNode(Text, {
                color: _unref(COLOR_SET).gray015,
                size: "14px"
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["color"])
            ]),
            _createElementVNode("li", null, [
              _createVNode(Text, {
                color: _unref(COLOR_SET).gray015,
                size: "14px"
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }, 8, ["color"])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})